// @ts-nocheck
/* Port of views/dashboard/module/VoicePlanDirectionsModal.js — byte-identical. */
import React, { useEffect, useState } from 'react';
import { AclSettingsModal, AclModalSection, FaMicrophone } from '@/features/acl-settings/aclSettingsUi';

const VoicePlanDirectionsModal = ({ show, onHide, initialDirections = [], onSave, directionOptions = [] }) => {
  const [selected, setSelected] = useState([]);
  const optionValues = (directionOptions || []).map((o) => o.value);

  useEffect(() => {
    if (show) {
      const initial = Array.isArray(initialDirections)
        ? initialDirections.map((d) => String(d).trim().toUpperCase())
        : [];
      const fromInitial = initial.filter((d) => optionValues.includes(d));
      setSelected(fromInitial.length > 0 ? fromInitial : [...optionValues]);
    }
  }, [show, initialDirections, directionOptions]);

  const toggle = (value) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const handleReset = () => setSelected([]);

  const handleSave = () => {
    onSave(selected);
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Voice Plan — Allowed Types"
      icon={FaMicrophone}
      description="Select which voice plan types users with this ACL can create and manage."
      limitedByParent={directionOptions.length < 3 && directionOptions.length > 0}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={selected.length === 0 || directionOptions.length === 0}
    >
      <AclModalSection
        icon={FaMicrophone}
        title="Plan Types"
        subtitle="Choose allowed voice plan directions."
      >
        {directionOptions.length === 0 ? (
          <p className="acl-modal-empty">
            You do not have permission to grant any voice plan types.
          </p>
        ) : (
          <div className="d-flex flex-wrap gap-3">
            {directionOptions.map((opt) => (
              <div key={opt.value} className="form-check acl-modal-check">
                <input
                  type="checkbox"
                  id={`vp-dir-${opt.value}`}
                  className="form-check-input"
                  checked={selected.includes(opt.value)}
                  onChange={() => toggle(opt.value)}
                />
                <label htmlFor={`vp-dir-${opt.value}`} className="form-check-label">
                  {opt.label}
                </label>
              </div>
            ))}
          </div>
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default VoicePlanDirectionsModal;
